import { Box, IconButton } from '@chakra-ui/react'
import { useState } from 'react'
import { MapLyingDownWithPin, SatelliteSignal } from 'components/icons'
import { useMapCoreManager } from '../../contexts/MapCoreManager/Provider'

export default function SimpleBaseLayerToogle({ defaultActiveBaseLayer = 'XYZ' }: { defaultActiveBaseLayer?: string }) {
  const { setBaseLayerSourceName } = useMapCoreManager()
  const [activeBaseLayer, setActiveBaseLayer] = useState(defaultActiveBaseLayer)

  function toogleBaseLayer() {
    if (activeBaseLayer == 'XYZ') {
      setBaseLayerSourceName('GOOGLE_SATELLITE')
      setActiveBaseLayer('GOOGLE_SATELLITE')
    } else {
      setBaseLayerSourceName('XYZ')
      setActiveBaseLayer('XYZ')
    }
  }

  return (
    <Box position="absolute" bottom="80px" right="2" zIndex="overlay">
      <IconButton
        rounded="full"
        aria-label="Toggle menu"
        icon={activeBaseLayer == 'XYZ' ? <SatelliteSignal boxSize={6} /> : <MapLyingDownWithPin boxSize={6} />}
        colorScheme="gray"
        size="md"
        onClick={() => toogleBaseLayer()}
        shadow="md"
      />
    </Box>
  )
}
